import { render, staticRenderFns } from "./Vehicle_Routes.vue?vue&type=template&id=22032f8a&"
import script from "./Vehicle_Routes.vue?vue&type=script&lang=js&"
export * from "./Vehicle_Routes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports